module.exports = __webpack_public_path__ + "img/right_arrow.c07ca9a4.svg";